import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-naac',
  templateUrl: './naac.component.html',
  styleUrls: ['./naac.component.scss']
})
export class NaacComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
